import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconAdjustmentsHorizontal, LazyIconAdjustmentsVertical, LazyIconAlarm, LazyIconArchiveX, LazyIconArrowLongDown, LazyIconArrowLongUp, LazyIconArrowPathRoundedSquare, LazyIconArrowPath, LazyIconArrowRight, LazyIconArrowTopRightOnSquare, LazyIconArrowTrendingUp, LazyIconArrowUTurnLeft, LazyIconArrowUTurnRight, LazyIconArrowsPointingOut, LazyIconArrowsUpDown, LazyIconBankNotes, LazyIconBars3CenterLeft, LazyIconBars3, LazyIconBarsArrowDown, LazyIconBarsArrowUp, LazyIconBarsBottomLeft, LazyIconBeaker, LazyIconBellAlert, LazyIconBell, LazyIconBolt, LazyIconBookmark, LazyIconBrain, LazyIconBuildingOffice, LazyIconCalendarDays, LazyIconCalendar, LazyIconChartBar, LazyIconChartPie, LazyIconChatBubble, LazyIconCheckCircleFill, LazyIconCheckCircle, LazyIconCheck, LazyIconChevronUpDown, LazyIconChevron, LazyIconCircleStack, LazyIconClipboardDocumentList, LazyIconClock, LazyIconCloudArrowDown, LazyIconCloudArrowUp, LazyIconCog, LazyIconCommandLine, LazyIconComputerDesktop, LazyIconCpuChip, LazyIconCurrencyDollar, LazyIconDashboard, LazyIconDoctor, LazyIconDocumentCheck, LazyIconDocumentDuplicate, LazyIconDocumentMagnify, LazyIconDocumentPlus, LazyIconDocumentText, LazyIconDocument, LazyIconDocx, LazyIconDraggable, LazyIconEditorAt, LazyIconEditorBlockQuote, LazyIconEditorBold, LazyIconEditorBulletList, LazyIconEditorClearFormat, LazyIconEditorH1, LazyIconEditorH2, LazyIconEditorHighlight, LazyIconEditorHorizontalRule, LazyIconEditorImage, LazyIconEditorItalic, LazyIconEditorLink, LazyIconEditorOrderedList, LazyIconEditorParagraph, LazyIconEditorPlaceholder, LazyIconEditorRedo, LazyIconEditorStrike, LazyIconEditorTaskList, LazyIconEditorTextWrap, LazyIconEditorUnderline, LazyIconEditorUndo, LazyIconEllipsisVertical, LazyIconEllipsis, LazyIconEnvelope, LazyIconExclamation, LazyIconExport, LazyIconEyeDropper, LazyIconEye, LazyIconFilm, LazyIconFolderPlus, LazyIconFolder, LazyIconForward, LazyIconFunnel, LazyIconGit, LazyIconGlobeAlt, LazyIconHashtag, LazyIconIdentification, LazyIconImport, LazyIconInfoCircle, LazyIconLightBulb, LazyIconLineChart, LazyIconListBullet, LazyIconLogout, LazyIconMegaphone, LazyIconMerge, LazyIconMinusCircle, LazyIconMinus, LazyIconPaintBrush, LazyIconPaperAirplane, LazyIconPaperClip, LazyIconPause, LazyIconPdf, LazyIconPencilSquare, LazyIconPencil, LazyIconPin, LazyIconPlay, LazyIconPlus, LazyIconPower, LazyIconPpt, LazyIconQrCode, LazyIconQuestionMarkCircle, LazyIconQueueList, LazyIconRectangleStack, LazyIconRepeat, LazyIconResearch, LazyIconScale, LazyIconSearch, LazyIconShare, LazyIconShield, LazyIconSparkles, LazyIconSpinner, LazyIconTableCells, LazyIconTag, LazyIconTemplate, LazyIconTimeline, LazyIconTrash, LazyIconType, LazyIconUploading, LazyIconUserCircleSolid, LazyIconUserGroup, LazyIconUserPlus, LazyIconUser, LazyIconUsers, LazyIconWrenchScrewDriver, LazyIconXCircleFill, LazyIconX, LazyIconYesOrNo } from '#components'
const lazyGlobalComponents = [
  ["IconAdjustmentsHorizontal", LazyIconAdjustmentsHorizontal],
["IconAdjustmentsVertical", LazyIconAdjustmentsVertical],
["IconAlarm", LazyIconAlarm],
["IconArchiveX", LazyIconArchiveX],
["IconArrowLongDown", LazyIconArrowLongDown],
["IconArrowLongUp", LazyIconArrowLongUp],
["IconArrowPathRoundedSquare", LazyIconArrowPathRoundedSquare],
["IconArrowPath", LazyIconArrowPath],
["IconArrowRight", LazyIconArrowRight],
["IconArrowTopRightOnSquare", LazyIconArrowTopRightOnSquare],
["IconArrowTrendingUp", LazyIconArrowTrendingUp],
["IconArrowUTurnLeft", LazyIconArrowUTurnLeft],
["IconArrowUTurnRight", LazyIconArrowUTurnRight],
["IconArrowsPointingOut", LazyIconArrowsPointingOut],
["IconArrowsUpDown", LazyIconArrowsUpDown],
["IconBankNotes", LazyIconBankNotes],
["IconBars3CenterLeft", LazyIconBars3CenterLeft],
["IconBars3", LazyIconBars3],
["IconBarsArrowDown", LazyIconBarsArrowDown],
["IconBarsArrowUp", LazyIconBarsArrowUp],
["IconBarsBottomLeft", LazyIconBarsBottomLeft],
["IconBeaker", LazyIconBeaker],
["IconBellAlert", LazyIconBellAlert],
["IconBell", LazyIconBell],
["IconBolt", LazyIconBolt],
["IconBookmark", LazyIconBookmark],
["IconBrain", LazyIconBrain],
["IconBuildingOffice", LazyIconBuildingOffice],
["IconCalendarDays", LazyIconCalendarDays],
["IconCalendar", LazyIconCalendar],
["IconChartBar", LazyIconChartBar],
["IconChartPie", LazyIconChartPie],
["IconChatBubble", LazyIconChatBubble],
["IconCheckCircleFill", LazyIconCheckCircleFill],
["IconCheckCircle", LazyIconCheckCircle],
["IconCheck", LazyIconCheck],
["IconChevronUpDown", LazyIconChevronUpDown],
["IconChevron", LazyIconChevron],
["IconCircleStack", LazyIconCircleStack],
["IconClipboardDocumentList", LazyIconClipboardDocumentList],
["IconClock", LazyIconClock],
["IconCloudArrowDown", LazyIconCloudArrowDown],
["IconCloudArrowUp", LazyIconCloudArrowUp],
["IconCog", LazyIconCog],
["IconCommandLine", LazyIconCommandLine],
["IconComputerDesktop", LazyIconComputerDesktop],
["IconCpuChip", LazyIconCpuChip],
["IconCurrencyDollar", LazyIconCurrencyDollar],
["IconDashboard", LazyIconDashboard],
["IconDoctor", LazyIconDoctor],
["IconDocumentCheck", LazyIconDocumentCheck],
["IconDocumentDuplicate", LazyIconDocumentDuplicate],
["IconDocumentMagnify", LazyIconDocumentMagnify],
["IconDocumentPlus", LazyIconDocumentPlus],
["IconDocumentText", LazyIconDocumentText],
["IconDocument", LazyIconDocument],
["IconDocx", LazyIconDocx],
["IconDraggable", LazyIconDraggable],
["IconEditorAt", LazyIconEditorAt],
["IconEditorBlockQuote", LazyIconEditorBlockQuote],
["IconEditorBold", LazyIconEditorBold],
["IconEditorBulletList", LazyIconEditorBulletList],
["IconEditorClearFormat", LazyIconEditorClearFormat],
["IconEditorH1", LazyIconEditorH1],
["IconEditorH2", LazyIconEditorH2],
["IconEditorHighlight", LazyIconEditorHighlight],
["IconEditorHorizontalRule", LazyIconEditorHorizontalRule],
["IconEditorImage", LazyIconEditorImage],
["IconEditorItalic", LazyIconEditorItalic],
["IconEditorLink", LazyIconEditorLink],
["IconEditorOrderedList", LazyIconEditorOrderedList],
["IconEditorParagraph", LazyIconEditorParagraph],
["IconEditorPlaceholder", LazyIconEditorPlaceholder],
["IconEditorRedo", LazyIconEditorRedo],
["IconEditorStrike", LazyIconEditorStrike],
["IconEditorTaskList", LazyIconEditorTaskList],
["IconEditorTextWrap", LazyIconEditorTextWrap],
["IconEditorUnderline", LazyIconEditorUnderline],
["IconEditorUndo", LazyIconEditorUndo],
["IconEllipsisVertical", LazyIconEllipsisVertical],
["IconEllipsis", LazyIconEllipsis],
["IconEnvelope", LazyIconEnvelope],
["IconExclamation", LazyIconExclamation],
["IconExport", LazyIconExport],
["IconEyeDropper", LazyIconEyeDropper],
["IconEye", LazyIconEye],
["IconFilm", LazyIconFilm],
["IconFolderPlus", LazyIconFolderPlus],
["IconFolder", LazyIconFolder],
["IconForward", LazyIconForward],
["IconFunnel", LazyIconFunnel],
["IconGit", LazyIconGit],
["IconGlobeAlt", LazyIconGlobeAlt],
["IconHashtag", LazyIconHashtag],
["IconIdentification", LazyIconIdentification],
["IconImport", LazyIconImport],
["IconInfoCircle", LazyIconInfoCircle],
["IconLightBulb", LazyIconLightBulb],
["IconLineChart", LazyIconLineChart],
["IconListBullet", LazyIconListBullet],
["IconLogout", LazyIconLogout],
["IconMegaphone", LazyIconMegaphone],
["IconMerge", LazyIconMerge],
["IconMinusCircle", LazyIconMinusCircle],
["IconMinus", LazyIconMinus],
["IconPaintBrush", LazyIconPaintBrush],
["IconPaperAirplane", LazyIconPaperAirplane],
["IconPaperClip", LazyIconPaperClip],
["IconPause", LazyIconPause],
["IconPdf", LazyIconPdf],
["IconPencilSquare", LazyIconPencilSquare],
["IconPencil", LazyIconPencil],
["IconPin", LazyIconPin],
["IconPlay", LazyIconPlay],
["IconPlus", LazyIconPlus],
["IconPower", LazyIconPower],
["IconPpt", LazyIconPpt],
["IconQrCode", LazyIconQrCode],
["IconQuestionMarkCircle", LazyIconQuestionMarkCircle],
["IconQueueList", LazyIconQueueList],
["IconRectangleStack", LazyIconRectangleStack],
["IconRepeat", LazyIconRepeat],
["IconResearch", LazyIconResearch],
["IconScale", LazyIconScale],
["IconSearch", LazyIconSearch],
["IconShare", LazyIconShare],
["IconShield", LazyIconShield],
["IconSparkles", LazyIconSparkles],
["IconSpinner", LazyIconSpinner],
["IconTableCells", LazyIconTableCells],
["IconTag", LazyIconTag],
["IconTemplate", LazyIconTemplate],
["IconTimeline", LazyIconTimeline],
["IconTrash", LazyIconTrash],
["IconType", LazyIconType],
["IconUploading", LazyIconUploading],
["IconUserCircleSolid", LazyIconUserCircleSolid],
["IconUserGroup", LazyIconUserGroup],
["IconUserPlus", LazyIconUserPlus],
["IconUser", LazyIconUser],
["IconUsers", LazyIconUsers],
["IconWrenchScrewDriver", LazyIconWrenchScrewDriver],
["IconXCircleFill", LazyIconXCircleFill],
["IconX", LazyIconX],
["IconYesOrNo", LazyIconYesOrNo],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
